import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as domain from '@common/domain/entities/Permission';
import * as models from '@common/domain/models/PermissionDTO';
import { IApiServiceCommand } from '@services/api/api.service';

export class RolePermissionEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/permissions",
    //url: app.config.controllerRouteRoot + "/role/getPermissions/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.context.entityId
      }
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/addPermission",
    //url: app.config.controllerRouteRoot + "/role/addPermission?roleId={context.parent.entityData.id}&permissionId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.context.entityId,
        permissionId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/removePermission",
    //url: app.config.controllerRouteRoot + "/role/removePermission?roleId={context.parent.entityData.id}&permissionId={data.id}"",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        roleId: serviceCommand.context.parent.parent.selectedItem.id,
        permissionId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}
export class RolePermissionAllEndPoints implements IEntityEndPoints {
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Role/addAllPermissions/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/Role/removeAllPermissions/" + serviceCommand.context.entityId
    },
    method: "POST"
  };
}
export class UserPermissionEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/getPermissions/" + serviceCommand.context.entityId
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/addPermission",
    //url: app.config.controllerRouteRoot + "/user/addPermission?userId={context.parent.entityData.id}&permissionId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        permissionId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/user/removePermission",
    //url: app.config.controllerRouteRoot + "/user/removePermission?userId={context.parent.entityData.id}&permissionId={data.id}"",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        permissionId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}

export class UserPermissionListSetup implements IGridOptions {
  protected userPermissionListName: string = "userPermissionList";
  protected userPermissionListModel: models.PermissionDTO = new models.PermissionDTO();
  protected userPermissionListEndPoints: domain.PermissionEndPoints = new domain.PermissionEndPoints();
  protected userPermissionListColumns: UserPermissionListColumns = new UserPermissionListColumns();
  public get name(): string { return this.userPermissionListName };
  public get model(): models.PermissionDTO { return this.userPermissionListModel };
  public get endPoints(): IEntityEndPoints { return this.userPermissionListEndPoints };
  public set endPoints(permissionEndPoints: IEntityEndPoints) {
    this.userPermissionListEndPoints = permissionEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): UserPermissionListColumns { return this.userPermissionListColumns };
}

export class PermissionList implements IGridOptions {
  protected permissionListName: string = "permissionList";
  protected permissionListModel: models.PermissionDTO = new models.PermissionDTO();
  protected permissionListEndPoints: domain.PermissionEndPoints = new domain.PermissionEndPoints();
  public get name(): string { return this.permissionListName };
  public get model(): models.PermissionDTO { return this.permissionListModel };
  public get endPoints(): IEntityEndPoints { return this.permissionListEndPoints };
  public set endPoints(permissionEndPoints: IEntityEndPoints) {
    this.permissionListEndPoints = permissionEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
}

export class RolePermissionListColumns extends Array<IColumnOptions> {
  public selected: IColumnOptions = { field: "selected", width: "140px" };
  public name: IColumnOptions = { field: "name" };
  public description: IColumnOptions = { field: "description" };
  constructor() {
    super();
    this.push(this.selected);
    this.push(this.name);
    this.push(this.description);
    this.selected.readOnly = false;
    this.selected.endPoints = new RolePermissionEndPoints();
    this.selected.selectAllEndPoints = new RolePermissionAllEndPoints();
  }
}

export class RolePermissionListSetup implements IGridOptions {
  protected rolePermissionListName: string = "rolePermissionList";
  protected rolePermissionListModel: models.PermissionDTO = new models.PermissionDTO();
  protected rolePermissionListEndPoints: domain.PermissionEndPoints = new domain.PermissionEndPoints();
  protected rolePermissionListColumns: RolePermissionListColumns = new RolePermissionListColumns();
  public get name(): string { return this.rolePermissionListName };
  public get model(): models.PermissionDTO { return this.rolePermissionListModel };
  public get endPoints(): IEntityEndPoints { return this.rolePermissionListEndPoints };
  public set endPoints(permissionEndPoints: IEntityEndPoints) {
    this.rolePermissionListEndPoints = permissionEndPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): RolePermissionListColumns { return this.rolePermissionListColumns };
}


export class RolePermissionList extends RolePermissionListSetup implements IGridOptions {
	protected rolePermissionListEndPoints: RolePermissionEndPoints = new RolePermissionEndPoints();
	protected rolePermissionListColumns: RolePermissionListColumns = new RolePermissionListColumns();
}

export class UserPermissionListColumns extends domain.PermissionListColumns {
	constructor() {
      super();
      this.splice(0, this.length);
      this.push(this.selected);
      this.push(this.name)
      this.selected.readOnly = false;
      this.selected.endPoints = new UserPermissionEndPoints();
      var permissionName = { field: "parentPermissionName",visible:false };
      this.push(permissionName);
      
	}
}
export class UserPermissionList extends UserPermissionListSetup implements IGridOptions {
  protected userPermissionListEndPoints: UserPermissionEndPoints = new UserPermissionEndPoints();
  protected userPermissionListColumns: UserPermissionListColumns = new UserPermissionListColumns();
  public disableNavigation: boolean = true;
  public tableIsGrouped: boolean = true;
  public groupingField: string = 'parentPermissionName';
  public autoExpandRows: boolean = true;
}
